"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardManager = void 0;
var AchievementsManager_1 = require("./../../AchievementsManager");
var GameVars_1 = require("../../GameVars");
var BoardScene_1 = require("./BoardScene");
var GameManager_1 = require("../../GameManager");
var BoardContainer_1 = require("./board/BoardContainer");
var GameConstants_1 = require("../../GameConstants");
var BoardManager = /** @class */ (function () {
    function BoardManager() {
    }
    BoardManager.init = function () {
        BoardManager.f = 0;
        GameVars_1.GameVars.clicksSpawning = 10;
        GameVars_1.GameVars.clicks = 1;
        GameVars_1.GameVars.isFreeCell = true;
        GameVars_1.GameVars.mysteriousItemProbability = .15;
        GameVars_1.GameVars.carouselActive = false;
        BoardManager.addEarnedCoins();
    };
    BoardManager.update = function () {
        if (GameVars_1.GameVars.paused) {
            return;
        }
        BoardManager.f++;
        if (BoardManager.f === 60) {
            BoardManager.f = 0;
            BoardManager.calculateCoinsPerSecond();
            GameVars_1.GameVars.modeGameData.coins += GameVars_1.GameVars.coinsPerSecond;
            BoardScene_1.BoardScene.currentInstance.updateCoinsCounters();
            if (!GameVars_1.GameVars.carouselActive) {
                BoardManager.decreaseClicksCounter();
            }
            GameVars_1.GameVars.modeGameData.lastTimestamp = Date.now();
            GameManager_1.GameManager.writeGameData();
        }
    };
    BoardManager.addEarnedCoins = function () {
        BoardManager.calculateCoinsPerSecond();
        var seconds = Math.round((Date.now() - GameVars_1.GameVars.modeGameData.lastTimestamp) / 1000);
        GameVars_1.GameVars.earnedCoins = Math.round(GameVars_1.GameVars.coinsPerSecond * seconds * 1000) / 1000;
        var maxEarnedCoins = Math.round(GameVars_1.GameVars.coinsPerSecond * 24 * 60 * 60 * 1000) / 1000;
        if (GameVars_1.GameVars.earnedCoins >= maxEarnedCoins) {
            GameVars_1.GameVars.earnedCoins = maxEarnedCoins;
        }
        GameVars_1.GameVars.modeGameData.coins += GameVars_1.GameVars.earnedCoins;
    };
    BoardManager.decreaseClicksCounter = function () {
        GameVars_1.GameVars.clicks--;
        var freeCellPosition = BoardManager.getFreeCell();
        if (freeCellPosition) {
            GameVars_1.GameVars.isFreeCell = true;
        }
        else {
            GameVars_1.GameVars.isFreeCell = false;
            GameVars_1.GameVars.clicks = GameVars_1.GameVars.clicksSpawning;
        }
        if (GameVars_1.GameVars.clicks <= 0) {
            GameVars_1.GameVars.clicks = GameVars_1.GameVars.clicksSpawning;
            if (freeCellPosition) {
                var isMysteriousItem = false;
                if (GameVars_1.GameVars.modeGameData.iMaxItemUncovered >= 6 + GameVars_1.GameVars.modeGameData.restartCounter) {
                    isMysteriousItem = Math.random() < GameVars_1.GameVars.mysteriousItemProbability;
                }
                BoardManager.spawnItem(GameVars_1.GameVars.modeGameData.restartCounter + 1, freeCellPosition, isMysteriousItem);
            }
        }
    };
    BoardManager.onDownCover = function (p, isMysteriousItem, itemPurchased) {
        GameVars_1.GameVars.coverPosition = p;
        GameVars_1.GameVars.modeGameData.boardConfiguration[p.r][p.c].c = 0;
        if (isMysteriousItem) {
            GameVars_1.GameVars.carouselActive = true;
        }
        BoardContainer_1.BoardContainer.currentInstance.uncoverItem(p, isMysteriousItem, itemPurchased);
        if (GameVars_1.GameVars.gameData.tutorialPhase === 1) {
            BoardManager.startTutorialPhase2();
        }
        else if (GameVars_1.GameVars.gameData.tutorialPhase === 2) {
            BoardManager.startTutorialPhase3();
        }
    };
    BoardManager.startTutorialPhase2 = function () {
        GameVars_1.GameVars.gameData.tutorialPhase = 2;
        BoardScene_1.BoardScene.currentInstance.startTutorialPhase2();
    };
    BoardManager.startTutorialPhase3 = function () {
        GameVars_1.GameVars.gameData.tutorialPhase = 3;
        BoardScene_1.BoardScene.currentInstance.startTutorialPhase3();
    };
    BoardManager.startTutorialPhase4 = function () {
        GameVars_1.GameVars.gameData.tutorialPhase = 4;
        BoardScene_1.BoardScene.currentInstance.startTutorialPhase4();
    };
    BoardManager.endTutorial = function () {
        GameVars_1.GameVars.paused = false;
        GameVars_1.GameVars.gameData.tutorialPhase = 0;
        BoardScene_1.BoardScene.currentInstance.onTutorialDone();
        GameManager_1.GameManager.writeGameData();
    };
    BoardManager.onMysteriousItemDetermined = function (n) {
        GameVars_1.GameVars.carouselActive = false;
        BoardContainer_1.BoardContainer.currentInstance.onMysteriousItemDetermined(n);
        BoardManager.needLevelUp(n);
    };
    BoardManager.onMysteriousItemDeterminedPowerUp = function (n) {
        GameVars_1.GameVars.carouselActive = false;
        BoardContainer_1.BoardContainer.currentInstance.onMysteriousItemDeterminedPowerUp();
        BoardManager.needLevelUp(n);
    };
    BoardManager.onItemPicked = function (p) {
        GameVars_1.GameVars.modeGameData.boardConfiguration[p.r][p.c].n = 0;
    };
    BoardManager.onItemReleased = function (goalCell, originCell, n) {
        if (goalCell) {
            var cellData = GameVars_1.GameVars.modeGameData.boardConfiguration[goalCell.r][goalCell.c];
            if (cellData.n === 0) {
                // celda vacia, se puede añadir
                GameVars_1.GameVars.modeGameData.boardConfiguration[goalCell.r][goalCell.c].n = n;
                BoardContainer_1.BoardContainer.currentInstance.dropSelectedItem();
            }
            else if (n !== GameConstants_1.GameConstants.NUM_ITEMS && cellData.n === n && cellData.c === 0) {
                // MERGE!
                GameVars_1.GameVars.modeGameData.boardConfiguration[goalCell.r][goalCell.c].n++;
                BoardManager.onItemsMerged(n);
            }
            else if (cellData.c !== 0) {
                // vuelve a la celda de donde salio
                GameVars_1.GameVars.modeGameData.boardConfiguration[originCell.r][originCell.c].n = n;
                BoardContainer_1.BoardContainer.currentInstance.returnItemToOrigin();
            }
            else {
                // HACER UN SWAP
                GameVars_1.GameVars.modeGameData.boardConfiguration[originCell.r][originCell.c].n = GameVars_1.GameVars.modeGameData.boardConfiguration[goalCell.r][goalCell.c].n;
                GameVars_1.GameVars.modeGameData.boardConfiguration[goalCell.r][goalCell.c].n = n;
                BoardContainer_1.BoardContainer.currentInstance.returnItemToOrigin();
                BoardContainer_1.BoardContainer.currentInstance.swapItems(originCell, goalCell);
            }
        }
        else {
            // vuelve a la celda de donde salio
            GameVars_1.GameVars.modeGameData.boardConfiguration[originCell.r][originCell.c].n = n;
            BoardContainer_1.BoardContainer.currentInstance.returnItemToOrigin();
        }
        GameManager_1.GameManager.writeGameData();
    };
    BoardManager.onItemsMerged = function (n) {
        AchievementsManager_1.AchievementsManager.updateAchievement(GameConstants_1.GameConstants.ACHIEVEMENTS_MERGE);
        BoardScene_1.BoardScene.currentInstance.onItemsMerged();
        GameVars_1.GameVars.newCell = false;
        var newItem = false;
        if (n + 1 > GameVars_1.GameVars.modeGameData.iMaxItemUncovered) {
            newItem = true;
            GameVars_1.GameVars.modeGameData.iMaxItemUncovered = n + 1;
            GameVars_1.GameVars.paused = true;
            AchievementsManager_1.AchievementsManager.updateAchievement(GameConstants_1.GameConstants.ACHIEVEMENTS_UNLOCK);
            BoardScene_1.BoardScene.currentInstance.showNewItemLayer();
            if (GameVars_1.GameVars.modeGameData.iMaxItemUncovered >= GameConstants_1.GameConstants.RESTART_ITEM + GameVars_1.GameVars.modeGameData.restartCounter && GameVars_1.GameVars.modeGameData.restartCounter < 15) {
                BoardScene_1.BoardScene.currentInstance.showRestartButton();
            }
            if (GameVars_1.GameVars.modeGameData.restartCounter + 1 <= GameVars_1.GameVars.modeGameData.iMaxItemUncovered - 4) {
                BoardScene_1.BoardScene.currentInstance.markShop();
            }
            if (GameVars_1.GameVars.gameData.tutorialPhase === 3) {
                BoardManager.startTutorialPhase4();
            }
        }
        BoardManager.needLevelUp(n, newItem);
    };
    BoardManager.needLevelUp = function (n, newItem) {
        var partialCounter = GameVars_1.GameVars.modeGameData.starsPartialCounter + n;
        if (partialCounter >= GameVars_1.GameVars.starsThresholdValues[GameVars_1.GameVars.modeGameData.stars]) {
            GameVars_1.GameVars.newCell = true;
            GameVars_1.GameVars.modeGameData.starsPartialCounter = partialCounter - GameVars_1.GameVars.starsThresholdValues[GameVars_1.GameVars.modeGameData.stars];
            GameVars_1.GameVars.modeGameData.stars++;
            if (GameVars_1.GameVars.modeGameData.stars === GameConstants_1.GameConstants.MODE_2_AVAILABLE_LEVEL && !GameVars_1.GameVars.gameData.isMode2Available) {
                GameVars_1.GameVars.gameData.isMode2Available = true;
                GameVars_1.GameVars.needShowNewArea = true;
            }
            AchievementsManager_1.AchievementsManager.updateAchievement(GameConstants_1.GameConstants.ACHIEVEMENTS_LEVEL);
            if (!newItem) {
                BoardManager.showLevelUpLayer();
            }
        }
        else {
            GameVars_1.GameVars.modeGameData.starsPartialCounter = partialCounter;
        }
        BoardScene_1.BoardScene.currentInstance.updateStartsContainer();
    };
    BoardManager.removeNewItemLayer = function () {
        BoardScene_1.BoardScene.currentInstance.hideNewItemLayer();
        if (GameVars_1.GameVars.gameData.tutorialPhase === 4) {
            GameVars_1.GameVars.gameData.tutorialPhase = 5;
            BoardScene_1.BoardScene.currentInstance.startTutorialPhase5();
        }
        else {
            if (GameVars_1.GameVars.newCell) {
                BoardManager.showLevelUpLayer();
            }
            else {
                GameVars_1.GameVars.paused = false;
            }
        }
    };
    BoardManager.showWelcomeBackLayer = function () {
        if (GameVars_1.GameVars.earnedCoins > 0 && (Date.now() - GameVars_1.GameVars.modeGameData.lastWelcomeShown) / 1000 > 30) {
            GameVars_1.GameVars.modeGameData.lastWelcomeShown = Date.now();
            GameVars_1.GameVars.paused = true;
            BoardScene_1.BoardScene.currentInstance.showWelcomeBackLayer();
        }
    };
    BoardManager.hideWelcomeBackLayer = function () {
        GameVars_1.GameVars.paused = false;
        BoardScene_1.BoardScene.currentInstance.hideWelcomeBackLayer();
    };
    BoardManager.showNewAreaLayer = function () {
        GameVars_1.GameVars.paused = true;
        BoardScene_1.BoardScene.currentInstance.showNewAreaLayer();
    };
    BoardManager.hideNewAreaLayer = function () {
        GameVars_1.GameVars.paused = false;
        BoardManager.addCell();
        BoardScene_1.BoardScene.currentInstance.hideNewAreaLayer();
    };
    BoardManager.showRestartLayer = function () {
        GameVars_1.GameVars.paused = true;
        BoardScene_1.BoardScene.currentInstance.showRestartLayer();
    };
    BoardManager.hideRestartLayer = function () {
        GameVars_1.GameVars.paused = false;
        BoardScene_1.BoardScene.currentInstance.hideRestartLayer();
    };
    BoardManager.showNewBadgeLayer = function () {
        GameVars_1.GameVars.paused = true;
        GameVars_1.GameVars.needShowNewBudget = false;
        BoardScene_1.BoardScene.currentInstance.showNewBadgeLayer();
    };
    BoardManager.hideNewBadgeLayer = function () {
        GameVars_1.GameVars.paused = false;
        BoardScene_1.BoardScene.currentInstance.hideNewBadgeLayer();
    };
    BoardManager.showScrollingLayer = function (name) {
        GameVars_1.GameVars.paused = true;
        BoardScene_1.BoardScene.currentInstance.showScrollingLayer(name);
    };
    BoardManager.hideScrollingLayer = function () {
        GameVars_1.GameVars.paused = false;
        BoardScene_1.BoardScene.currentInstance.hideScrollingLayer();
    };
    BoardManager.showLevelUpLayer = function () {
        GameVars_1.GameVars.paused = true;
        BoardScene_1.BoardScene.currentInstance.showLevelUpLayer();
    };
    BoardManager.removeLevelUpLayer = function () {
        BoardScene_1.BoardScene.currentInstance.hideLevelUpLayer();
        if (GameVars_1.GameVars.needShowNewArea) {
            GameVars_1.GameVars.needShowNewArea = false;
            BoardManager.showNewAreaLayer();
        }
        else {
            GameVars_1.GameVars.paused = false;
            BoardManager.addCell();
        }
    };
    BoardManager.removeNewGameModeLayer = function () {
        GameVars_1.GameVars.paused = false;
        BoardManager.showWelcomeBackLayer();
    };
    BoardManager.restartMode = function () {
        GameVars_1.GameVars.modeGameData.coins = 0;
        GameVars_1.GameVars.modeGameData.stars = 0;
        GameVars_1.GameVars.modeGameData.starsPartialCounter = 0;
        GameVars_1.GameVars.modeGameData.restartCounter++;
        GameVars_1.GameVars.modeGameData.iMaxItemUncovered = GameVars_1.GameVars.modeGameData.restartCounter + 1;
        GameVars_1.GameVars.modeGameData.boardConfiguration = null;
        GameVars_1.GameVars.modeGameData.canRestart = false;
        GameVars_1.GameVars.needShowNewBudget = true;
        if (GameVars_1.GameVars.isDesktop) {
            GameVars_1.GameVars.modeGameData.boardConfiguration = [
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: 0, c: 0 }, { n: 0, c: 0 }, { n: 0, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: 0, c: 0 }, { n: 0, c: 0 }, { n: 0, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }]
            ];
        }
        else {
            GameVars_1.GameVars.modeGameData.boardConfiguration = [
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: 0, c: 0 }, { n: 0, c: 0 }, { n: 0, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: 0, c: 0 }, { n: 0, c: 0 }, { n: 0, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }],
                [{ n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }, { n: -1, c: 0 }]
            ];
        }
        GameVars_1.GameVars.paused = false;
        GameManager_1.GameManager.writeGameData();
        GameManager_1.GameManager.enterBoardScene();
    };
    BoardManager.onGiftClaimed = function () {
        var freeCellPosition = BoardManager.getFreeCell();
        if (freeCellPosition) {
            var min = GameVars_1.GameVars.modeGameData.restartCounter + 2;
            var max = GameVars_1.GameVars.modeGameData.iMaxItemUncovered - 2;
            var array = [];
            for (var i = 0; i < max - min; i++) {
                array.push(i + min);
                if (i < ((max - min) * 2) / 3) {
                    array.push(i + min);
                }
                if (i < (max - min) / 3) {
                    array.push(i + min);
                }
            }
            var n = array[Math.floor(Math.random() * array.length)];
            BoardManager.spawnItem(n, null, false, false, true);
            GameVars_1.GameVars.modeGameData.timeLastGift = Date.now() / 1000;
            GameManager_1.GameManager.writeGameData();
        }
        else {
            BoardScene_1.BoardScene.currentInstance.hideScrollingLayer();
            BoardScene_1.BoardScene.currentInstance.showEmptySpacesLayer();
        }
    };
    BoardManager.onItemPurchased = function (i) {
        var freeCellPosition = BoardManager.getFreeCell();
        if (freeCellPosition) {
            AchievementsManager_1.AchievementsManager.updateAchievement(GameConstants_1.GameConstants.ACHIEVEMENTS_BUY);
            GameVars_1.GameVars.modeGameData.coins -= GameVars_1.GameVars.shopItemsPrices[i - 1] * (1 + GameVars_1.GameVars.modeGameData.itemsPurchased[i - 1].count * GameConstants_1.GameConstants.SHOW_INCREMENT_PERCENTAGE);
            GameVars_1.GameVars.modeGameData.itemsPurchased[i - 1].count++;
            BoardManager.spawnItem(i, null, null, true);
            BoardScene_1.BoardScene.currentInstance.onItemPurchased();
        }
        else {
            BoardScene_1.BoardScene.currentInstance.hideScrollingLayer();
            BoardScene_1.BoardScene.currentInstance.showEmptySpacesLayer();
        }
    };
    BoardManager.hideEmptySpacesLayer = function () {
        GameVars_1.GameVars.paused = false;
        BoardScene_1.BoardScene.currentInstance.hideEmptySpacesLayer();
    };
    BoardManager.addCell = function () {
        var i = GameVars_1.GameVars.getNumActiveCells() - 6;
        var p;
        if (GameVars_1.GameVars.isDesktop) {
            p = GameConstants_1.GameConstants.CELLS_SEQUENCE_DESKTOP[i];
        }
        else {
            p = GameConstants_1.GameConstants.CELLS_SEQUENCE_TACTILE[i];
        }
        GameVars_1.GameVars.modeGameData.boardConfiguration[p.r][p.c] = { n: 0, c: 0 };
        BoardContainer_1.BoardContainer.currentInstance.addCell(p);
    };
    BoardManager.claimAchievement = function (i, index) {
        GameVars_1.GameVars.modeGameData.achievementsData[i].claims[index] = true;
        var prize = GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1 ?
            GameVars_1.GameVars.currentScene.cache.json.get("achievements")["MODE_1"][i].prizes[index] :
            GameVars_1.GameVars.currentScene.cache.json.get("achievements")["MODE_2"][i].prizes[index];
        GameVars_1.GameVars.modeGameData.coins += prize;
        BoardScene_1.BoardScene.currentInstance.unmarkAchievements();
        BoardScene_1.BoardScene.currentInstance.updateCoinsCounters();
        GameManager_1.GameManager.writeGameData();
    };
    BoardManager.getFreeCell = function () {
        var freeCells = [];
        for (var r = 0; r < GameVars_1.GameVars.modeGameData.boardConfiguration.length; r++) {
            var row = GameVars_1.GameVars.modeGameData.boardConfiguration[r];
            for (var c = 0; c < row.length; c++) {
                var cellData = row[c];
                if (cellData.n === 0) {
                    freeCells.push({ c: c, r: r });
                }
            }
        }
        return Phaser.Utils.Array.GetRandom(freeCells);
    };
    BoardManager.getFreeCellsCount = function () {
        var count = 0;
        var value = 100;
        for (var r = 0; r < GameVars_1.GameVars.modeGameData.boardConfiguration.length; r++) {
            var row = GameVars_1.GameVars.modeGameData.boardConfiguration[r];
            for (var c = 0; c < row.length; c++) {
                var cellData = row[c];
                if (cellData.n === 0) {
                    count++;
                }
                else {
                    if (cellData.n > 0 && cellData.n < value) {
                        value = cellData.n;
                    }
                }
            }
        }
        if (count === 1) {
            return value;
        }
        return -1;
    };
    BoardManager.spawnItem = function (n, freeCellPosition, isMysteriousItem, itemPurchased, isGiftItem) {
        freeCellPosition = freeCellPosition || BoardManager.getFreeCell();
        var c = 1;
        if (isMysteriousItem) {
            c = 2;
            var min = GameVars_1.GameVars.modeGameData.restartCounter + 2;
            var max = GameVars_1.GameVars.modeGameData.iMaxItemUncovered - 2;
            var array = [];
            for (var i = 0; i < max - min; i++) {
                array.push(i + min);
                if (i < ((max - min) * 2) / 3) {
                    array.push(i + min);
                }
                if (i < (max - min) / 3) {
                    array.push(i + min);
                }
            }
            n = array[Math.floor(Math.random() * array.length)];
        }
        var minValue = BoardManager.getFreeCellsCount();
        if (minValue !== -1 && !itemPurchased) {
            n = minValue;
            isMysteriousItem = minValue !== GameVars_1.GameVars.modeGameData.restartCounter + 1;
        }
        var cellData = { n: n, c: c };
        GameVars_1.GameVars.modeGameData.boardConfiguration[freeCellPosition.r][freeCellPosition.c] = cellData;
        BoardContainer_1.BoardContainer.currentInstance.spawnItem(freeCellPosition, isMysteriousItem || isGiftItem, itemPurchased);
        GameManager_1.GameManager.writeGameData();
    };
    BoardManager.calculateCoinsPerSecond = function () {
        GameVars_1.GameVars.coinsPerSecond = 0;
        for (var r = 0; r < GameVars_1.GameVars.modeGameData.boardConfiguration.length; r++) {
            var row = GameVars_1.GameVars.modeGameData.boardConfiguration[r];
            for (var c = 0; c < row.length; c++) {
                if (row[c].n > 0 && row[c].c === 0) {
                    GameVars_1.GameVars.coinsPerSecond += (GameVars_1.GameVars.itemCoinsPerSecond[row[c].n - 1] * (1 + GameVars_1.GameVars.modeGameData.restartCounter * .1));
                }
            }
        }
    };
    return BoardManager;
}());
exports.BoardManager = BoardManager;
